<template>
  <div class="col-sm-4">
    <h5 class="title_base">{{ $t('bikeOverview.bikeInformation.eSystem.' + arrSystemTemp.Device) }}</h5>
    <ul class="bikeinfo_list list_eSystem list_titleStyle list-unstyled">
      <li :data-tit="$t('bikeOverview.bikeInformation.eSystem.name')">{{ PartName }}</li>
      <li :data-tit="$t('bikeOverview.bikeInformation.eSystem.hardware')">{{ arrSystemTemp.HwVer }}</li>
      <li :data-tit="$t('bikeOverview.bikeInformation.eSystem.firmware')">{{ arrSystemTemp.FwVer }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'BikeInfoSysItem',
  data () {
    return {};
  },
  props: [
    'arrSystemTemp'
  ],
  computed: {
    PartName () {
      let partName = this.arrSystemTemp.PartName || '--';
      return partName;
    }
  }
};
</script>
